/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOverlayChart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 20V2H2v20h20v-2h-2v-6h-2v6h-2v-3h-2v3h-2v-4h-2v4H8v-3H6v3H4zm.77-9.915 15.826-7 .808 1.83-15.825 7-.81-1.83zM20 8v5h-2V8h2zm-4 2v6h-2v-6h2zm-4 2v3h-2v-3h2zm-6 4v-3h2v3H6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOverlayChart as OverlayChart };
